import * as actionTypes from '../action-types';
import { NotificationType } from '../../notification.types';
import { NotificationsActions } from '../actions';

type Reducer = Array<NotificationType>;

const defaultState: Reducer = [];

export function notifListReducer(
  state: Reducer = defaultState,
  action: NotificationsActions,
) {
  switch (action.type) {
    case actionTypes.SET_NOTIFICATIONS: {
      const { notifications } = action.payload;
      return notifications.map(
        ({ alreadyRead: status, ...notification }) =>
          notification as NotificationType,
      );
    }
    default: {
      return state;
    }
  }
}
